import styled from '@emotion/styled';
import { Select } from '@mui/material';
import { colors } from 'theme/colors';
import FormControl from '@mui/material/FormControl';

export const StyledFormControl = styled(FormControl)(() => ({
  width: '100%',
}));

export const StyledSelect = styled(Select)({
  '& .MuiOutlinedInput-root': {
    height: 40,
  },
  '#select': {
    padding: '8px 16px',
    fontSize: 14,
  },
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '.MuiSelect-select': {
    padding: '9px 12px',
    border: 0,
    ':disabled': {
      background: `${colors.gray100} !important`,
      '& input': {
        color: colors.gray300,
        background: `${colors.gray100} !important`,
      },
    },
  },
  '.Mui-disabled': {
    background: `${colors.gray100} !important`,
    '.MuiSelect-select': {
      color: colors.gray300,
      background: `${colors.gray100} !important`,
    },
  },
  '.MuiMenuItem-root': {
    width: '100%',
    fontSize: 14,
    boxSizing: 'border-box',

    '& .MuiSelect-select': {
      height: 40,
      padding: 0,
      boxSizing: 'border-box',
    },
  },
  '& .MuiInputBase-input': {
    border: 0,
  },
  '& .MuiInputBase-root': {
    height: 40,
  },
  '#daysQuantity': {
    boxSizing: 'border-box',
    padding: '9px 12px',
    width: 65,
    height: 40,
    display: 'flex',
    alignItems: 'flex-end',
  },
});

export const StyledInnerWrapper = styled.div`
  font-size: 14px;
  height: 40px;

  & .MuiOutlinedInput-root {
    width: 100%;
    height: 40px;
    padding: 0;
    background-color: ${colors.white};
  }

  & .MuiSelect-select {
    height: 40px;
    box-sizing: border-box;
    background-color: ${colors.white};
  }
`;
